module.exports = __webpack_public_path__ + "static/media/HP Entreprenørmaskiner_2026_Logo.99625782.png";